/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Pipe, PipeTransform } from '@angular/core';
import { GtoUom } from '@gh/builder-shared-data';
import { getQuantityUomCode, Quantity } from '@gh/core-data';
import { getUomQuantityType } from './builder-quantity-types';

@Pipe({
  name: 'uomQuantityFormat',
  pure: true,
})
export class UomQuantityFormatPipe implements PipeTransform {
  transform(quantity: Maybe<Quantity<any>>): any {
    return quantity ?
      getUomQuantityType(<GtoUom>getQuantityUomCode(quantity)).format(quantity, { noLabels: false })
      : void 0;
  }
}
